<template>
<!--  <Content @back="$router.push('/home')">-->
  <Content @back = "back" :noBack="['expert','organ'].includes(userRole)">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn active" >
          <template v-if="userRole === 'system' || userRole === 'admin' ">
            教案/周训练计划（{{youthShortName}}）
          </template>
          <template v-else>
            教案/周训练计划
          </template>
        </div>
        <template v-if="!['system','admin'].includes(userRole)">
          <div class="btn "  @click="jumpTo('/plan/monthPlanList')">
            月训练计划
          </div>
          <div class="btn " @click="jumpTo('/plan/halfYearPlanList')">
            半年训练计划及小结
          </div>
          <div class="btn " @click="jumpTo('/plan/yearPlanList')">
            年度训练计划及总结
          </div>
        </template>
      </div>
    </template>
    <template v-if="userRole === 'coach'" v-slot:nav_right>
      <div class="yioks_btn" @click="isAddPlan = true;(isEdit = false), (planInfo = {});">
        添加周训练计划
      </div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="remember">
          <p>
            <span v-if="userRole === 'system' || userRole === 'admin'|| userRole === 'expert'">
              {{youthShortName}}
            </span>
            <span v-if="squadName">
              {{squadName}}
            </span>
            <span v-else>
              全部球队
            </span>
            <span v-if="selectVal.dateRange && selectVal.dateRange.length > 0">
              {{Number(selectVal.dateRange[0]) | time}} 至 {{Number(selectVal.dateRange[1]) | time}}
            </span>
            <span>
              训练总次数: {{trainingNumber}} 次
            </span>
          </p>
        </div>
        <div class="select_box">
          <template v-if="userRole !== 'coach'">
<!--            <select-->
<!--              v-model="selectVal.organUuid"-->
<!--              class="yioks_select"-->
<!--              @change="changeOrg"-->
<!--            >-->
<!--              <option v-if="organList.length > 1" value="">全部区体育行政部门</option>-->
<!--              <option-->
<!--                v-for="item in organList"-->
<!--                :key="item.organUuid"-->
<!--                :value="item.organUuid"-->
<!--              >-->
<!--                {{ item.organShortName }}-->
<!--              </option>-->
<!--            </select>-->
<!--            <select-->
<!--              v-model="selectVal.youthUuid"-->
<!--              class="yioks_select"-->
<!--              @change="changeCenter"-->
<!--            >-->
<!--              <option v-if="centerList.length !== 1" value="">-->
<!--                全部培训机构-->
<!--              </option>-->
<!--              <option-->
<!--                v-for="item in centerList"-->
<!--                :key="item.uuid"-->
<!--                :value="item.uuid"-->
<!--              >-->
<!--                {{ item.youthShortName }}-->
<!--              </option>-->
<!--            </select>-->
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeQuery(true)"
            >
<!--              <option v-if="squadList.length !== 1" value="">全部球队</option>-->
              <option value="">全部球队</option>
              <option
                v-for="item in squadList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.shortName }}
              </option>
            </select>
          </template>
          <template v-else>
            <select
              v-model="selectVal.squadUuid"
              class="yioks_select"
              @change="changeCoachCenter"
            >
              <option value="">
                全部球队
              </option>
              <option
                v-for="item in coachSquadSelectList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </template>

          <el-date-picker
            v-model="selectVal.dateRange"
            style="border-radius: 0;"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="changeCoachCenter">
          </el-date-picker>
        </div>
<!--        <div class="search_box">-->
<!--          <input-->
<!--            v-model.trim="selectVal.seacherString"-->
<!--            type="text"-->
<!--            class="yioks_input"-->
<!--            style="width: 160px"-->
<!--            placeholder="请输入关键字"-->
<!--            @keyup.enter="changeQuery(true)"-->
<!--          />-->
<!--          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>-->
<!--        </div>-->
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="table" v-if="plan && plan.length">
            <div class="thead">
              <div class="tr">
                <div class="th seq"><strong>序号</strong></div>
                <div class="th time"><strong>周时间段</strong></div>
                <div class="th squadName"><strong>球队名称</strong></div>
                <div class="th technicalProportion"><strong>技战术占比</strong></div>
                <div class="th physicalQualityProportion"><strong>身体素质占比</strong></div>
                <div class="th aheadTrainingAmount"><strong>训练负荷</strong></div>
                <div class="th aheadTrainingAmount"><strong>周总课次</strong></div>
                <div class="th trainingTime"><strong>训练总时长</strong></div>
                <div class="th opt"><strong>操作</strong></div>
              </div>
            </div>
            <div class="scrollArea">
              <vue-scroll>
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div v-for="(item, index) in plan" :key="index" class="tr">
                      <div class="td seq">
                        <p>{{ index + 1 }}</p>
                      </div>
                      <div class="td time" :title="$ok.date.formatDate(item.aheadTrainingStartTime)+'~'+$ok.date.formatDate(item.aheadTrainingEndTime)">
                        <p>{{ item.aheadTrainingStartTime | time }}~{{ item.aheadTrainingEndTime | time }}</p>
                      </div>
                      <div class="td squadName" :title="item.squadName">
                        <p>{{ item.squadName }}</p>
                      </div>
                      <div class="td technicalProportion">
                        <p>{{ item.technicalProportion || '0' }}%</p>
                      </div>
                      <div class="td physicalQualityProportion">
                        <p>{{ item.physicalQualityProportion || '0' }}%</p>
                      </div>
                      <div class="td aheadTrainingAmount">
                        <p>{{ item.aheadTrainingAmount }}</p>
                      </div>
                      <div class="td aheadTrainingAmount">
                        <template v-if="item.trainingNumber">
                          <p>{{ item.trainingNumber }}次</p>
                        </template>
                        <template v-else>
                          <p>--</p>
                        </template>
                      </div>
                      <div class="td trainingTime">
                        <template v-if="item.trainingTime">
                          <p>{{ parseInt(item.trainingTime / 60) }}时{{ parseInt(item.trainingTime % 60) }}分</p>
                        </template>
                        <template v-else>
                          <p>--</p>
                        </template>
                      </div>
                      <div class="td opt">
                        <p>
                          <span class="item" @click="goDetail(item.uuid,item.squadUuid,item.aheadTrainingStartTime,item.aheadTrainingEndTime,item.youthShortName)">日计划</span>
                          <br>
                          <template v-if="userRole === 'coach' && !item.isNotEdit">
                            <span class="item" @click="editPlan(item)">编辑</span>
                            <span  class="split">/</span>
                            <span class="item" @click="deletePlan(item.uuid)">删除</span>
                          </template>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
        </div>
          <yioks-loading v-if="loading"/>
          <template v-if="userRole === 'coach'">
            <yioks-empty
              v-if="empty"
              tips="暂时没有数据，"
              name="立即添加周训练计划"
              class="h"
              @callback="isAddPlan = true;(isEdit = false), (planInfo = {});"
            ></yioks-empty>
          </template>
          <template v-else>
            <yioks-empty v-if="empty" tips="暂时没有数据" class="h"></yioks-empty>
          </template>
      </div>
        <Pagination :total="total" :page.sync="page"/>
        <template v-if="isAddPlan">
          <AddPlanDialog
            :addPlan.sync="isAddPlan"
            :isEdit="isEdit"
            :plan="planInfo"
            @hideDialog="hideDialog"
          ></AddPlanDialog>
        </template>
        <yioks-tip
          :showTip="showTip"
          :tipMsg="'确定删除该周训练计划吗？删除后周训练计划中含有的日训练计划内容也将同步删除。'"
          @callback="isDelete"
        />
    </template>
  </Content>
</template>

<script>
import "vue-awesome/icons/regular/trash-alt";
import "vue-awesome/icons/regular/edit";
import plan from "@/api/plan";
import squad from "@/api/squad";
import person from "@/assets/images/common/person.jpg";
import storage from "@/utils/storage";
import rulesMixin from "@/utils/formRules/rulesMixin";
import {squadNameList} from "@/utils/yioks_data";
import { time } from '@/utils/yioks_filter'

export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    AddPlanDialog: () => import("./components/addPlan"),
  },
  mixins: [rulesMixin],
  data() {
    return {
      plan: "",
      trainingNumber: 0,
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      organList: [],
      centerList: [],
      batchOrganList: [],
      batchCenterList: [],
      batchSquadList: [],
      squadList: [],
      isAddPlan: false,
      selectVal: {
        organUuid: "",
        youthUuid: "",
        // seacherString: "",
        squadUuid: "",
        dateRange: [],
        dateRangeStart:'',
        dateRangeEnd:'',
      },
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        squadForCoach: '',  // 教练冗余数据
      },
      planInfo: {
        aheadTrainingName: "",
        aheadTrainingAmount: "",
        squadName: "",
        aheadTrainingDescription: "",
        aheadTrainingStartTime: "",
        aheadTrainingEndTime: "",
      },
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      showTip: false,
      loading: true,
      allSquad: "",
      planUuid: "",
      isEdit: false,
      squadNameList,
      squadName: "",
      coachSquadSelectList: [], // 教练员专用搜索选项
    };
  },
  watch: {
    page() {
      this.changeQuery();
    },
  },

  computed: {
    youthShortName() {
      const { youthShortName } = this.$route.query;
      return youthShortName;
    },
  },

  created() {
    const {page, squadUuid, organUuid, youthUuid,aheadTrainingStartTime,aheadTrainingEndTime} =
      this.$route.query;
    page && (this.page = Number(page));
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
    if(aheadTrainingStartTime && aheadTrainingEndTime){
      this.selectVal.dateRange.push(aheadTrainingStartTime);
      this.selectVal.dateRange.push(aheadTrainingEndTime);
    }else{
      let daStart = new Date().getFullYear() + '-01-01 00:00:01';
      let daEnd = new Date().getFullYear() + '-12-31 23:59:59';
      this.selectVal.dateRange.push(new Date(daStart).getTime());
      this.selectVal.dateRange.push(new Date(daEnd).getTime());
    }
    if (this.userRole === "coach") {
      this.getSearchSelectList();
    } else {
      this.getOrganListAndCenterList();
    }
    this.changeQuery(true);
  },
  methods: {
    goYear(){
      this.$router.push({
        path: "yearPlanList",
        query: {},
      });
    },
    goHalfYear(){
      this.$router.push({
        path: "halfYearPlanList",
        query: {},
      });
    },
    jumpTo(path) {
      if(this.userRole === 'expert' || this.userRole === 'organ' ){
        this.$router.replace({
          path: path,
          query: {
            organUuid:this.selectVal.organUuid,
            youthUuid:this.selectVal.youthUuid,
            squadUuid:this.selectVal.squadUuid,
          },
        });
      }else{
        this.$router.replace(path)
      }
    },
    goMonth(){
      this.$router.push({
        path: "monthPlanList",
        query: {},
      });
    },
    getplanList() {
      this.loading = true;
      this.showList = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") { // 系统管理员获取列表
        request = plan.getPlanSystem;
      } else if (this.userRole === "organ") { // 会员协会获取列表
        request = plan.getPlanListOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) { // 俱乐部获取列表
        request = plan.getPlanListYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") { // 教练获取列表
        request = plan.getPlanLeaderOrCoach;
      }
      let data = {
        page: this.page,
        size: this.pageSize,
        squadUuid: this.selectVal.squadUuid,
        organUuid: this.selectVal.organUuid,
        // key: this.selectVal.seacherString,
        youthUuid: this.selectVal.youthUuid,
        aheadTrainingStartTime: this.selectVal.dateRange ? this.selectVal.dateRange[0] :'',
        aheadTrainingEndTime: this.selectVal.dateRange ? this.selectVal.dateRange[1] :'',
      };
      request(data)
        .then((res) => {
          this.loading = false;
          this.total = res.totalElements;
          if (res.content.length) {
            this.plan = res.content;
            const now = new Date();
            const fourteenDaysLater = new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000); // 十四天前  第14天也可以编辑
            console.log(fourteenDaysLater.getTime())
            this.plan.map(item=>{
              if (item.aheadTrainingEndTime < fourteenDaysLater.getTime()) {
               // 结束14天了
//                item.isNotEdit = true;
              }
            })
            this.showList = true;
            this.empty = false;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },

    getTrainingNumber() {
      this.loading = true;
      this.empty = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") { // 系统管理员获取列表
        request = plan.getPlanSystemToTrainingNumber;
      } else if (this.userRole === "organ") { // 会员协会获取列表
        request = plan.getPlanListOrganToTrainingNumber;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) { // 俱乐部获取列表
        request = plan.getPlanListYouthToTrainingNumber;
      } else if (this.userRole === "leader" || this.userRole === "coach") { // 教练获取列表
        request = plan.getPlanLeaderOrCoachToTrainingNumber;
      }
      let data = {
        page: this.page,
        size: this.pageSize,
        squadUuid: this.selectVal.squadUuid,
        organUuid: this.selectVal.organUuid,
        // key: this.selectVal.seacherString,
        youthUuid: this.selectVal.youthUuid,
        aheadTrainingStartTime: this.selectVal.dateRange ? this.selectVal.dateRange[0] :'',
        aheadTrainingEndTime: this.selectVal.dateRange ? this.selectVal.dateRange[1] :'',
      };
      request(data)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.trainingNumber = res;
          }else{
            this.trainingNumber = 0;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    isDelete(isSure) {
      if (isSure) {
        plan.deletePlan(this.planUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.getplanList();
            this.getTrainingNumber();
            this.showTip = false;
          }
        });
      } else {
        this.showTip = false;
      }
    },
    editPlan(row) {
      this.planInfo = row;
      this.isAddPlan = true;
      this.isEdit = true;
    },
    deletePlan(uuid) {
      this.showTip = true;
      this.planUuid = uuid;
    },

    goDetail(aheadTrainingUuid,squadUuid,aheadTrainingStartTime,aheadTrainingEndTime,youthShortName) {
      this.$router.push({
        path: "/training/list",
        query: {
          aheadTrainingUuid,
          squadUuid,
          aheadTrainingStartTime,
          aheadTrainingEndTime,
          youthShortName,
        },
      });
    },

    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        this.batchOrganList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            // if (this.selectVal.squadUuid) {  // 不清楚为什么有一个判断，现在去掉判断可以满足功能，先暂时去掉
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            // }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
              }
            }
          }
        }
        this.squadList.forEach((item) => {
          if(item.uuid === this.selectVal.squadUuid){
            this.squadName = item.shortName;
          }
        });
        if(!this.selectVal.squadUuid) this.squadName = "";
      });
    },

    // 教练员搜索选项
    getSearchSelectList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.coachSquadSelectList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
            value: item.squadUuid,
            key: JSON.stringify({squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid})
          }));
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    changeOrg() {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const {youthList} = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },
    changeCenter() {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },
    changeCoachCenter() {
      this.changeQuery(true);
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.page,
          // seacherString: this.selectVal.seacherString,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
          aheadTrainingStartTime: this.selectVal.dateRange ? this.selectVal.dateRange[0] :'',
          aheadTrainingEndTime: this.selectVal.dateRange ? this.selectVal.dateRange[1] :'',
        },
      });
      this.getplanList();
      this.getTrainingNumber();

      // 获取搜索框球队名称
      this.squadList.forEach((item) => {
        if(item.uuid === this.selectVal.squadUuid){
          this.squadName = item.shortName;
        }
      });
      if(!this.selectVal.squadUuid) this.squadName = "";
    },
    hideDialog(val) {
      this.isAddPlan = val;
      this.getplanList();
      this.getTrainingNumber();
    },
    back(){
      if (this.userRole === "system" || this.userRole === "admin" ){
        // this.$router.go(-1)
        this.$router.push('/plan/adminPlanList')
        // this.$router.push({path: "list"})
      }else if ( this.userRole === "expert" || this.userRole === "organ"){
        this.$router.go(-1)
      }else {
        this.$router.push('/home')
      }
//      this.$router.go(-1)
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'

::v-deep .nav_left
  padding-right 10px !important

.nav-btn-box
  display flex
  .btn
    margin-right 15px
    padding 10px 5px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;

    .thead, .tbody
      border 1px solid $color_white

    .thead
      margin 0 40px

      .tr
        height 45px
        display flex

    .scrollArea
      height 425px
      padding-bottom 15px

    /* flex 1 */
    /* overflow hidden */

    .tbodyWrap
      display block

    // padding: 0 40px;

    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none

      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white

    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      text-align center
      font-size $font_size_medium
      border-right 1px solid $color_white

    .th:last-child, .td:last-child
      border-right none

    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white

    .technicalProportion
      width 8%

    .physicalQualityProportion
      width 9%

      p {
        padding 0 4px
      }

    .seq
      width 5%

    .squadName
      width 22%

    .aheadTrainingAmount
      width 6%

    .trainingTime
      width 11%

    .time
      width 22%

    .opt
      width 13%

      p
        width 100%
        text-align center

        .item
          cursor pointer
          user-select none
          color $green_color

        .split
          margin 0 5px

.demo-ruleForm
  height 475px

.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word

.yioks_select
  width 130px !important

.h
  height 450px


.select_wrap {
  position: relative;

  .remember {
    position: absolute;
    top: -22px;
    right: 0;
    color: #FF0000;
    font-weight: bold;

    a {
      color: #FF0000;
    }
  }
}

/deep/.el-date-editor .el-range-separator
  width 10%

</style>
